import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Container, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from "react-i18next";

import AuctionManagement from "./auctionManagement";
import UserManagement from "./userManagement";
import InvoiceManagement from "./invoiceManagement";
import { Helmet } from 'react-helmet-async';

const Management = () => {

    const [tabIndex, setTabIndex] = useState(0);
    const { t } = useTranslation();

    useEffect(() => {

    }, []);

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <Container maxWidth="lg">
                <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                    <Tabs
                        value={tabIndex}
                        onChange={(e, newValue) => setTabIndex(newValue)}
                        aria-label="management tabs"
                    >
                        <Tab label={t("admin.auctions")} />
                        <Tab label={t("admin.users")} />
                        <Tab label={t("admin.invoices")} />
                        {/* Add more tabs as needed */}
                    </Tabs>
                </Box>

                {tabIndex === 0 && (
                    <AuctionManagement />
                )}
                {tabIndex === 1 && (
                    <UserManagement />
                )}
                {tabIndex === 2 && (
                    <InvoiceManagement />
                )}
            </Container>
        </>
    );

};

export default Management;
